export default __webpack_public_path__ + "static/media/label_delivery.66adf0c2.svg";